import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["data", "style", "columns", "onRowClick", "onPageClick", "rowHeight", "rowStyle", "tableHeaderHeight", "isChecked", "pageSize", "loading", "EmptyPlaceholder"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import withFixedColumns from 'react-table-hoc-fixed-columns';
import _noop from 'lodash/noop';
import _get from 'lodash/get';
import 'react-table/react-table.css';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import BaseTable from './BaseTable';
import './table.module.scss';

// Constants
import COLORS from 'tstyles/variables.scss';

// Helpers
import { makeGetTrProps } from './helpers/rowHelpers';
var ReactTableFixedColumns = withFixedColumns(BaseTable);
var FixedColumnTable = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FixedColumnTable, _React$PureComponent);
  var _super = _createSuper(FixedColumnTable);
  function FixedColumnTable(props) {
    var _this;
    _classCallCheck(this, FixedColumnTable);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getRowProps", function (state, rowInfo, dummy, tableInstance, parentProps) {
      var rowStyle = _this.props.rowStyle;
      var prevSetBackground = _get(parentProps, 'style.backgroundColor');
      if (rowInfo && rowInfo.row && !prevSetBackground) {
        return {
          style: _objectSpread({
            backgroundColor: COLORS.white
          }, rowStyle)
        };
      }
    });
    _this.getTrProps = makeGetTrProps(props.getTrProps, _this.getRowProps);
    return _this;
  }
  _createClass(FixedColumnTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        data = _this$props.data,
        style = _this$props.style,
        columns = _this$props.columns,
        onRowClick = _this$props.onRowClick,
        onPageClick = _this$props.onPageClick,
        rowHeight = _this$props.rowHeight,
        rowStyle = _this$props.rowStyle,
        tableHeaderHeight = _this$props.tableHeaderHeight,
        isChecked = _this$props.isChecked,
        pageSize = _this$props.pageSize,
        loading = _this$props.loading,
        EmptyPlaceholder = _this$props.EmptyPlaceholder,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(ReactTableFixedColumns, _extends({
        data: data,
        columns: columns,
        onRowClick: onRowClick,
        style: style,
        innerRef: function innerRef(r) {
          _this2.reactTableFixedColumns = r;
        } // Do not change the ref name
        ,
        onPageClick: onPageClick,
        rowHeight: rowHeight,
        rowStyle: rowStyle,
        tableHeaderHeight: tableHeaderHeight,
        isChecked: isChecked,
        pageSize: pageSize,
        loading: loading,
        EmptyPlaceholder: EmptyPlaceholder
      }, rest, {
        getTrProps: this.getTrProps
      }));
    }
  }]);
  return FixedColumnTable;
}(React.PureComponent);
_defineProperty(FixedColumnTable, "propTypes", {
  onRowClick: PropTypes.func,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  style: PropTypes.any,
  onPageClick: PropTypes.func,
  rowStyle: PropTypes.object,
  rowHeight: PropTypes.number,
  tableHeaderHeight: PropTypes.number,
  isChecked: PropTypes.func,
  pageSize: PropTypes.number
});
_defineProperty(FixedColumnTable, "defaultProps", {
  onRowClick: _noop,
  style: {},
  onPageClick: _noop,
  rowStyle: EMPTY_OBJECT,
  rowHeight: 30,
  tableHeaderHeight: 40,
  isChecked: _noop,
  pageSize: 10
});
export default FixedColumnTable;